export default __webpack_public_path__ + "static/media/43.4396307b.jpeg";